import React from 'react'
import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Button } from '@mui/material'
import moment from 'moment/moment'
import { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import {
  crdeitDrawCellDetail,
  excelHeaderColumn,
  excelHeaderCreditSummaryReport,
  excelHeaderCreditSummaryReport1,
  lrDetailPdfFooter,
  pdfCreditSummaryReport,
} from './../common/AcountingConstants'
import { focusElemnt, navigation3 } from '../../../common/helper'
import * as id from './../common/AcountingId'

const TableViewCreditSummary = ({ loginData, tableData, fromDate, toDate, company, StateName, city, party, updateScreen }) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [showTable, setShowTable] = useState(true)
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  let openingBalance = tableData?.Table?.length > 0 ? tableData?.Table[0]?.OpeningBalance : 0
  let netbooking =
    tableData?.Table?.length > 0
      ? tableData?.Table[0]?.BookingCredit -
      tableData?.Table[0]?.BookingCreditRefund
      : 0
  let netReceivable = tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCredit - tableData?.Table[0]?.DeliveryCreditRefund : 0
  let netCollectable = tableData?.Table?.length > 0 ? tableData?.Table[0]?.Debit - tableData?.Table[0]?.Credit : 0
  let closingBalance = tableData?.Table?.length > 0 ? openingBalance + netCollectable + netbooking + netReceivable - (tableData?.Table?.length > 0 ? tableData?.Table[0]?.Recharges : 0) : 0
  const printClick = (isSave) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])

    const pdfColumns = pdfCreditSummaryReport.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderColumns = excelHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })

    const HeaderData = [
      {
        company: company,
        state: StateName,
        city: city,
        party: party,
      },
    ]
    // bodyData for credit Summary report
    const bodyData = [
      {
        Head: 'Opening Balance (A)',
        TransactionType: 'A = G (Closing of Prev. Day)',
        TransactionAmount: '',
        TotalAmount: openingBalance,
      },
      {
        Head: '',
        TransactionType: 'Booking Credit (a)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCredit : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Booking Credit Refund (b)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCreditRefund : 0,
        TotalAmount: '',
      },

      {
        Head: 'Net Booking (B)',
        TransactionType: 'B = ( a - b )',
        TransactionAmount: '',
        TotalAmount: netbooking,
      },
      {
        Head: '',
        TransactionType: 'Delivery Credit (c)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCredit : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Delivery Credit Refund (d)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCreditRefund : 0,
        TotalAmount: '',
      },
      {
        Head: 'Net Receivable (C)',
        TransactionType: 'C = ( c - d )',
        TransactionAmount: '',
        TotalAmount: netReceivable,
      },
      {
        Head: '',
        TransactionType: 'Debit Note (e)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.Debit : 0,
        TotalAmount: '',
      },
      {
        Head: '',
        TransactionType: 'Credit Note (f)',
        TransactionAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.Credit : 0,
        TotalAmount: '',
      },
      {
        Head: 'Net Collectable (D)',
        TransactionType: 'D = ( e - f )',
        TransactionAmount: '',
        TotalAmount: netCollectable,
      },
      {
        Head: 'Payment Received (E)',
        TransactionType: 'F = Amount Received',
        TransactionAmount: '',
        TotalAmount: tableData?.Table?.length > 0 ? tableData?.Table[0]?.Recharges : 0,
      },
      {
        Head: 'Closing Balance (F)',
        TransactionType: 'G = ( A + B + C + D - E )',
        TransactionAmount: '',
        TotalAmount: closingBalance,
      },
    ]

    const doc = new jsPDF({ orientation: 'P', format: [1080, 1528], unit: 'px', compress: true })
    var totalPagesExp = '{total_pages_count_string}'
    doc.setProperties({
      title: `Party Credit Limit Summary Reports.pdf`,
      subject: 'Party Credit Limit Summary Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      columnStyles: {
        0: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        1: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        2: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
        3: {
          fontSize: 18,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          cellPadding: 12,
          minCellHeight: 36,
          halign: 'left',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      startY: 160,
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        font: 'Roboto',
        fontStyle: 'normal',
        lineWidth: 0.6,
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18).setFont('Roboto', 'bold')
        doc.text(
          `Booking Date: ${moment(fromDate).format('DD-MMM-YYYY')}  To  ${moment(toDate).format('DD-MMM-YYYY')} `,
          data.settings.margin.left,
          150
        )
        // doc.text(`Report View: Detailed`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
      },
    })
    autoTable(doc, {
      margin: { top: 120, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      headStyles: {
        fillColor: [191, 225, 255],
        fontSize: 16,
        minCellHeight: 36,
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        font: 'Roboto',
        textColor: [0, 0, 0],
      },
      tableLineWidth: 0.6,
      columns: pdfColumns,
      body: bodyData,
      styles: {
        lineWidth: [0, 0.2, 0, 0.2],
      },
      //---------------data of table-----------
      columnStyles: {
        0: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        1: {
          halign: 'left',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        2: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
        3: {
          halign: 'right',
          minCellHeight: 36,
          fontSize: 16,
          cellPadding: 6,
          valign: 'middle',
          fontStyle: 'normal',
          font: 'Roboto',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      didParseCell: (data) => {
        crdeitDrawCellDetail(data)
      },
      didDrawPage: function (data) {
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Party Credit Limit Summary Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        lrDetailPdfFooter(data, loginData, totalPagesExp)
      },
      // showHead: 'never',
    })
    doc.setFont('Roboto')

    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Party Credit Limit Summary Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Party Credit Limit Summary Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    } else {
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('creditLimitTransReport').data = pdfUrl
        // document.getElementById('creditLimitTransReport').data = doc.output('datauristring', ' Party Credit Limit Summary Reports.pdf')
        focusElemnt('backBtn')
      }, 2000)
    }
  }
  const InsideRowContent = () => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Opening Balance (A)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              A = G (Closing of Prev. Day)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{openingBalance}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Credit (a)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCredit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Credit Refund (b)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCreditRefund : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top', borderBottom: 'none' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >Net Booking (B)</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              B = ( a - b )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{netbooking}</TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Credit (c)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCredit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Credit Refund (d)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCreditRefund : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Receivable (C)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              C = ( c - d )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{netReceivable}</TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Debit Note (e)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.Debit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Credit Note (f)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.Credit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Collectable (D)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              D = ( e - f )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netCollectable}
            </TableCell>
          </>
        </TableRow>

        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >Payment Received (E)</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              F = Amount Received
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{tableData?.Table?.length > 0 ? tableData?.Table[0]?.Recharges : 0}</TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left' }}
            >
              Closing Balance (F)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              G = ( A + B + C + D - E )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '14px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {closingBalance}
            </TableCell>
          </>
        </TableRow>

      </>
    )
  }
  const InsideRowContentForExcel = () => {
    return (
      <>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Opening Balance (A)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              A = G (Closing of Prev. Day)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {openingBalance}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Credit (a)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCredit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Booking Credit Refund (b)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.BookingCreditRefund : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top', borderBottom: 'none' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >Net Booking (B)</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              B = ( a - b )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{netbooking}</TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Credit (c)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCredit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Delivery Credit Refund (d)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.DeliveryCreditRefund : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Receivable (C)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              C = ( c - d )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{netReceivable}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Debit Note (e)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.Debit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              Credit Note (f)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {tableData?.Table?.length > 0 ? tableData?.Table[0]?.Credit : 0}
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Net Collectable (D)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              D = ( e - f )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {netCollectable}
            </TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >Payment Received (E)</TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              F = Amount Received
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >

            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >{tableData?.Table?.length > 0 ? tableData?.Table[0]?.Recharges : 0}</TableCell>
          </>
        </TableRow>
        <TableRow style={{ verticalAlign: 'top' }}>
          <>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
            >
              Closing Balance (F)
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'left', whiteSpace: 'nowrap' }}
            >
              G = ( A + B + C + D - E )
            </TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            ></TableCell>
            <TableCell
              className="reportTD"
              colSpan={1}
              style={{ background: 'F5FAFE', fontSize: '16px', fontWeight: '500', textAlign: 'right', whiteSpace: 'nowrap' }}
            >
              {closingBalance}
            </TableCell>
          </>
        </TableRow>
      </>
    )
  }

  return (
    <>
      <Box className="userReport" style={{ display: 'flex', width: '100%', height: '40px', padding: '12px 0px', marginRight: '0px' }}>
        <Box style={{ display: 'flex', width: '50%', justifyContent: 'flex-start', alignItems: 'center', gap: '12px', fontSize: '14px' }}>
          <h3 style={{ textAlign: 'left', color: '#444', paddingLeft: '16px' }}>Report For: Party Credit Limit Summary Report</h3>
        </Box>
        <Box
          className="userReport-buttons"
          style={{
            display: 'flex',
            width: '50%',
            justifyContent: 'end',
            alignItems: 'center',
            paddingRight: '16px',
          }}
        >
          {showTable ? (
            <>
              <Box onKeyDown={(e) => navigation3(e, 'creditSummaryPdfBtn', id.creditSummarySplitButton, () => { })}>
                <ReactHtmlTableToExcel
                  //id="test-table-xls-button"
                  id="creditSummaryExcelBtn"
                  className="userWisereporttemExcelBtn"
                  // className="receiveitemExcelBtn"
                  table="table-to-xls1"
                  filename={`Party Credit Limit Summary Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  id="creditSummaryPdfBtn"
                  onKeyDown={(e) =>
                    navigation3(e, 'creditSummaryPrintBtn', 'creditSummaryExcelBtn', () => {
                      printClick(true)
                    })
                  }
                  className="userWisereporttembtn"
                  onClick={() => printClick(true)}
                >
                  Export to Pdf
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  id="creditSummaryPrintBtn"
                  onKeyDown={(e) =>
                    navigation3(e, id.creditSummaryFromDate, 'creditSummaryPdfBtn', () => {
                      printClick(false)
                    })
                  }
                  className="userWisereporttembtn"
                  onClick={() => printClick(false)}
                >
                  Print
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Box>
                <Button
                  id="backBtn"
                  variant="outlined"
                  className="userWisereporttembtn"
                  onClick={() => (setShowTable(true), updateScreen())}
                >
                  Back
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Box>
      {showTable ? (
        <>
          <Stack
            sx={{ marginLeft: 2, marginRight: 2, height: 440, paddingTop: '10px', marginBottom: '16px' }}
            className="changeScrollColor"
          >
            <TableContainer className="scroll" style={{ borderRadius: '6px', border: '1px solid rgb(224 224 224)', width: '75%' }}>
              {/* ---------------Table For Excel--------------- */}
              <Table id="table-to-xls1" className="table1 table-Report" size="small" aria-label="a dense table" style={{ display: 'none' }}>
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow style={{ fontSize: '18px', fontWeight: '500', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={2}>
                      Report For: Party Credit Limit Summary Report
                    </TableCell>
                    <TableCell className="reportTD" colSpan={3}>
                      Company Name : _Maven Tech Services Pvt. Ltd.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditSummaryReport1?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={2} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    {excelHeaderCreditSummaryReport?.map((item, i) => (
                      <TableCell
                        className="ReportItemHead"
                        style={{ backgroundColor: '#e5f3ff', color: '#444', fontSize: '16px', fontWeight: '500', textAlign: 'left' }}
                        colSpan={item.col}
                        key={i}
                      >
                        {item.value}
                      </TableCell>
                    ))}
                  </TableRow>
                  <TableRow style={{ fontSize: '16px', textAlign: 'left' }}>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{company}</span>
                    </TableCell>
                    {/* <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(fromDate).format('DD/MM/YYYY')}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{moment(toDate).format('DD/MM/YYYY')}</span>
                    </TableCell> */}
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{StateName}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{city}</span>
                    </TableCell>
                    <TableCell className="reportTD" colSpan={1} style={{ textAlign: 'left', fontWeight: '200' }}>
                      <span>{party}</span>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={12}></TableCell>
                  </TableRow>
                  <TableRow
                    style={{
                      verticalAlign: 'top',
                    }}
                  >
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Head
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Type
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Amount
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '16px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Total Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                {/* {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? ( */}
                <TableBody
                  className="filter-data-row"
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  <InsideRowContentForExcel />
                </TableBody>
                {/*  ) : (  ''  )} */}
              </Table>
              <Table id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ fontWeight: 'bold', position: 'sticky', top: '0' }}>
                  {/* -------TableHeader--------- */}
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{
                        fontWeight: 'bold',
                        backgroundColor: '#bfe1ff',
                        color: '#444',
                        position: 'sticky',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        borderBottom: 'none',
                      }}
                      colSpan={15}
                    >
                      Party Credit Limit Summary Report
                    </TableCell>
                  </TableRow>
                  <TableRow
                    style={{
                      backgroundColor: '#e5f3ff',
                      verticalAlign: 'top',
                    }}
                  >
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Head
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'left',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Type
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Transaction Amount
                    </TableCell>
                    <TableCell
                      className="ReportItemHead"
                      style={{
                        backgroundColor: '#e5f3ff',
                        color: '#444',
                        fontSize: '14px',
                        fontWeight: '500',
                        textAlign: 'right',
                        whiteSpace: 'nowrap',
                      }}
                      colSpan={1}
                    >
                      Total Amount
                    </TableCell>
                  </TableRow>
                </TableHead>
                {/* {tableData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={15}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '14px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : tableData?.length >= 1 ? ( */}
                <TableBody
                  className="filter-data-row"
                  style={{
                    textAlign: 'center',
                    fontSize: '14px',
                    lineheight: '16px',
                    letterspacing: '0.24px',
                    fontWeight: '500',
                    marginLeft: '5px',
                  }}
                >
                  <InsideRowContent />
                </TableBody>
                {/*  ) : (  ''  )} */}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="creditLimitTransReport"
              type="application/pdf"
              width={'100%'}
              height="440"
              title="MTLPL -Cargo System - After Transfer Summary Report"
              aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              style={{ marginTop: '10px' }}
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}
export default TableViewCreditSummary
